import { Component, Input } from '@angular/core';
import {
  BaseShiftIconsEnum,
  BaseWeekDays,
  BaseWeekDaysAlt,
  CustomerInquiryOfferProfileListItemResponse,
  ProfileForAssignmentCustomerResponse,
  WeekdaysArrayAlt,
} from 'base';

@Component({
  selector: 'base-customer-shift-readiness',
  templateUrl: './base-customer-shift-readiness.component.html',
})
export class BaseCustomerShiftReadinessComponent {
  @Input() profile: CustomerInquiryOfferProfileListItemResponse | ProfileForAssignmentCustomerResponse;

  weekdaysArray: [BaseWeekDays, BaseWeekDaysAlt][] = WeekdaysArrayAlt;
  shiftTimes = Object.entries(BaseShiftIconsEnum);
}
